import React, { memo, SVGProps } from 'react'

export const ExclamationMark = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.8 6C11.3627 6 11 6.36267 11 6.8V13.9787C11 14.416 11.3627 14.7787 11.8 14.7787C12.2373 14.7787 12.6 14.416 12.6 13.9787V6.8C12.6 6.36267 12.2373 6 11.8 6Z"
      fill="currentColor"
    />
    <path
      d="M11.8 18.3947C12.0133 18.3947 12.216 18.3093 12.3653 18.16C12.5147 18.0213 12.6 17.8187 12.6 17.6053C12.6 17.392 12.5147 17.1787 12.3653 17.0293C12.1413 16.8053 11.7893 16.7413 11.4907 16.8587C11.3947 16.9013 11.3093 16.9547 11.2347 17.0293C11.0853 17.1787 11 17.392 11 17.6053C11 17.808 11.0853 18.0213 11.2347 18.16C11.384 18.3093 11.5867 18.3947 11.8 18.3947Z"
      fill="currentColor"
    />
  </svg>
))
